/**
 * Suppress benign ResizeObserver loop errors (MUI Dialog, TextareaAutosize, Tooltip).
 * CRA dev overlay listens on window "error" — must use capture + preventDefault.
 */
export function suppressResizeObserverLoopError() {
  const isResizeObserverNoise = (message) =>
    typeof message === "string" &&
    (message.includes("ResizeObserver loop") ||
      message.includes("ResizeObserver loop limit exceeded"));

  window.addEventListener(
    "error",
    (event) => {
      if (isResizeObserverNoise(event?.message)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const msg = event?.reason?.message;
      if (isResizeObserverNoise(msg)) {
        event.preventDefault();
      }
    },
    true
  );

  const nativeConsoleError = window.console.error.bind(window.console);
  window.console.error = (...args) => {
    if (args.some((arg) => isResizeObserverNoise(typeof arg === "string" ? arg : arg?.message))) {
      return;
    }
    nativeConsoleError(...args);
  };
}
